const restrictedPermissions: Record<string, string[]> = {
  admin: ["delete:admin"],
  standard: [
    // Standard role restrictions - cannot perform these actions
    "delete:contacts",
    "update:contacts",
    "block:contacts",
    "import:contacts",
    "export:contacts",
    "access:myBusinessMenu",
    "access:billingMenu",
  ],
  owner: [
    // Owner has no restrictions - can access everything
    // This is intentionally empty to allow full access
  ],
};

export const checkPermissions = (
  userRole: string,
  action: string,
  resource: string
) => {
  // By default, all roles have access to everything
  let hasAccess = true;

  // Check if the role has any restrictions
  const restrictions =
    restrictedPermissions[userRole as keyof typeof restrictedPermissions];

  if (restrictions) {
    if (restrictions.includes(`${action}:${resource}`)) {
      hasAccess = false;
    }
  }

  return hasAccess;
};
